import { render } from "./NewXmlandFileDifMenu.vue?vue&type=template&id=ad0d76d0&scoped=true"
import script from "./NewXmlandFileDifMenu.vue?vue&type=script&lang=js"
export * from "./NewXmlandFileDifMenu.vue?vue&type=script&lang=js"

import "./NewXmlandFileDifMenu.vue?vue&type=style&index=0&id=ad0d76d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad0d76d0"]])

export default __exports__